export const CATEGORY_PATH = {
  MATERIALS: 'materials',
  SECTIONS: 'sections',
  REBAR_MESHES: 'rebar-meshes',
  CONNECTION_ELEMENTS: 'connection-elements',
};